import { useTrackerAuth } from "components/AuthProvider";
import { EcsUserType } from "lib/shared/users/getEcsUserType";
import { Company, CompanyType, User } from "prisma/cm/client";

import { BENCHMARK_DATASET } from "../constants/enums";

export function useAuthorizedDataSets(defaultUser?: User & { company: Company }) {
  const { user: authUser, pending } = useTrackerAuth();

  let user = authUser;

  if (!user && defaultUser) {
    //@ts-expect-error TS2322
    user = defaultUser;
  }

  const datasets: Record<BENCHMARK_DATASET, boolean> = {
    comprehensive: false,
    comptryx: false,
    mercer: false,
    carta: false,
    salary: false,
    ecs: false,
  };

  // Public benchmarking site - logged out users and free benchmarking users get comprehensive access
  // If auth is still pending, show loading
  if (pending) {
    return { datasets, isLoading: true };
  }

  // If user is null after auth resolves (logged out) or they are a free
  // benchmarking user (no company), give comprehensive access.
  if (!user || !user.company) {
    datasets.comprehensive = true;
    return { datasets, isLoading: false };
  }

  // require company admin or benchmarking access unless company is a VC, then allow ECS access regardless of role and benchmarking access
  if (
    user.role !== "COMPANY_ADMIN" &&
    !user.enableBenchmarkingAccess &&
    user.company?.companyType !== CompanyType.VC
  ) {
    return { datasets, isLoading: false };
  }

  // All companies have comprehensive access
  datasets.comprehensive = true;

  const company = user.company as Company;

  if (company.companyType === CompanyType.VC) {
    datasets.ecs = true;
    return { datasets, isLoading: false };
  }

  if (company.enableAdminComptryxBenchmarking) {
    datasets.comptryx = true;
  }

  if (company.enableAdminMercerBenchmarking) {
    datasets.mercer = true;
  }

  if (company.enableSalaryComBenchmarking) {
    datasets.salary = true;
  }

  if (
    company.enableEcsBenchmarking ||
    (user.ecsUserType && user.ecsUserType !== EcsUserType.UNKNOWN)
  ) {
    datasets.ecs = true;
  }

  return { datasets, isLoading: false };
}
